webpackJsonp([9],{

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _CalculatorInput = __webpack_require__(85);

var _CalculatorInput2 = _interopRequireDefault(_CalculatorInput);

var _Responsive = __webpack_require__(25);

var _Utils = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoanRepaymentCalculator = function (_React$Component) {
  _inherits(LoanRepaymentCalculator, _React$Component);

  _createClass(LoanRepaymentCalculator, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(LoanRepaymentCalculator, props), document.getElementById(id));
    }
  }, {
    key: 'renderDetails',
    value: function renderDetails() {
      return _react2.default.createElement(
        'div',
        { className: 'loan-repayment-calculator-description' },
        _react2.default.createElement(
          'h2',
          null,
          'Loan Repayment Calculator'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Methodology'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The Loan Repayment Calculator was created to help you determine how much you will pay in total for a loan. Input the original loan amount, the repayment terms in months, and the monthly interest, to determine the total interest you will pay on the loan over the loan period, and the total repayment including that interest.'
        )
      );
    }
  }]);

  function LoanRepaymentCalculator() {
    _classCallCheck(this, LoanRepaymentCalculator);

    var _this = _possibleConstructorReturn(this, (LoanRepaymentCalculator.__proto__ || Object.getPrototypeOf(LoanRepaymentCalculator)).call(this));

    _this.state = {
      loanAmount: '0',
      repaymentTerm: '0',
      interestPercent: '0',
      totalInterestResult: '0',
      totalRepaymentResult: '0'
    };
    _this.calculateResults = _this.calculateResults.bind(_this);
    return _this;
  }

  _createClass(LoanRepaymentCalculator, [{
    key: 'calculateResults',
    value: function calculateResults() {
      var totalInterest = 0;
      var totalRepayment = 0;
      var currentBalance = +this.state.loanAmount;
      var principal = currentBalance / +this.state.repaymentTerm;

      for (var i = 0; i < +this.state.repaymentTerm; i += 1) {
        var interestDecimal = +this.state.interestPercent / 100;
        var currentInterest = currentBalance * (interestDecimal / +this.state.repaymentTerm);
        var currentPayment = principal + currentInterest;

        currentBalance -= principal;
        totalInterest += currentInterest;
        totalRepayment += +currentPayment;
      }

      this.setState({
        totalInterestResult: (0, _Utils.formatNumber)(totalInterest.toFixed(2)),
        totalRepaymentResult: (0, _Utils.formatNumber)(totalRepayment.toFixed(2))
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'container loan-repayment-calculator-container' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-2 col-md-offset-1 loan-repayment-calculator-inputs' },
            _react2.default.createElement(
              _Responsive.LargeMobile,
              null,
              LoanRepaymentCalculator.renderDetails()
            ),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'LOAN AMOUNT',
              value: this.state.loanAmount,
              onChange: function onChange(loanAmount) {
                return _this2.setState({ loanAmount: loanAmount });
              },
              type: 'monetary'
            }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'REPAYMENT TERM (MONTHS)',
              value: this.state.repaymentTerm,
              onChange: function onChange(repaymentTerm) {
                return _this2.setState({ repaymentTerm: repaymentTerm });
              }
            }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'INTEREST (MONTHLY)',
              value: this.state.interestPercent,
              onChange: function onChange(interestPercent) {
                return _this2.setState({ interestPercent: interestPercent });
              },
              type: 'percent'
            }),
            _react2.default.createElement('span', { className: 'divider' }),
            _react2.default.createElement(
              'button',
              { onClick: this.calculateResults },
              ' Calculate '
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-7 col-md-offset-1 loan-repayment-calculator-right-col' },
            _react2.default.createElement(
              _Responsive.Desktop,
              null,
              LoanRepaymentCalculator.renderDetails()
            ),
            _react2.default.createElement(
              'div',
              { className: 'loan-repayment-calculator-results-container' },
              _react2.default.createElement('div', { className: 'caret' }),
              _react2.default.createElement(
                'div',
                { className: 'loan-repayment-calculator-results-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'loan-repayment-calculator-results' },
                  _react2.default.createElement(_CalculatorInput2.default, {
                    title: 'TOTAL INTEREST',
                    value: this.state.totalInterestResult,
                    type: 'monetary',
                    disabled: true
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'loan-repayment-calculator-results' },
                  _react2.default.createElement(_CalculatorInput2.default, {
                    title: 'TOTAL REPAYMENT',
                    value: this.state.totalRepaymentResult,
                    type: 'monetary',
                    disabled: true
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LoanRepaymentCalculator;
}(_react2.default.Component);

exports.default = LoanRepaymentCalculator;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _LoanRepaymentCalculator = __webpack_require__(444);

var _LoanRepaymentCalculator2 = _interopRequireDefault(_LoanRepaymentCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.LoanRepaymentCalculator = _LoanRepaymentCalculator2.default;

/***/ })

},[465]);


// WEBPACK FOOTER //
// seo-loan-repayment-calculator.js